import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUserEmail: builder.mutation<
      void,
      { accountId: string; userId: string; email: string }
    >({
      query: ({ accountId, userId, email }) => ({
        url: `v4/accounts/${accountId}/users/${userId}/email`,
        body: { email },
        method: 'PUT',
      }),
      invalidatesTags: (result, error) => (error ? [] : ['User']),
    }),
  }),
});

export const { useUpdateUserEmailMutation } = apiSlice;
